import gql from 'gql-tag'
import { TASK_IDENTIFIER_CODE_SYSTEM, VisitTaskIdentifiers } from 'fhir/Task/constants'
import { BASE_ENCOUNTER_FRAGMENT } from 'fragments/encounter.query'
import { BASE_APPOINTMENT_FRAGMENT } from 'fragments/appointment.query'
import { BASE_PRACTITIONER_FRAGMENT } from 'fragments/practitioner.query'
import { BASE_PATIENT_FRAGMENT } from 'fragments/patient.query'
import { BASE_TASK_FRAGMENT } from 'fragments/task.query'
import { BASE_EPISODE_OF_CARE_FRAGMENT } from 'fragments/episodeOfCare.query'

const taskIdentifierFilter = `${TASK_IDENTIFIER_CODE_SYSTEM}|${VisitTaskIdentifiers.join(
  `,${TASK_IDENTIFIER_CODE_SYSTEM}|`
)}`

export const GET_VISIT_FRAGMENT = gql`
  fragment GetCNAVisit_Visit on Encounter {
    ...BaseEncounter
    visitQATasks: TaskList(_reference: focus, code: $taskCode, _count: 1000, _sort: "-_lastUpdated") {
      ...BaseTask
    }
    episodeOfCare {
      resource {
        ...BaseEpisodeOfCare
      }
    }
    appointment {
      resource {
        ...BaseAppointment
      }
    }
    interventions: TaskList(_reference: encounter, identifier: "${taskIdentifierFilter}", _count: 1000, _sort: "-_lastUpdated") {
      ...BaseTask
    }
  }
`

export const GET_CAREGIVER_VISIT = gql`
  query GetCNAVisit($visitId: ID!, $taskCode: String!) {
    Encounter(id: $visitId) {
      ...GetCNAVisit_Visit
    }
  }
  ${GET_VISIT_FRAGMENT}
  ${BASE_ENCOUNTER_FRAGMENT}
  ${BASE_APPOINTMENT_FRAGMENT}
  ${BASE_PRACTITIONER_FRAGMENT}
  ${BASE_PATIENT_FRAGMENT}
  ${BASE_EPISODE_OF_CARE_FRAGMENT}
  ${BASE_TASK_FRAGMENT}
`
